import * as ngCore from '@angular/core'

import * as scenarioDropdown from './scenario-dropdown'

@ngCore.Component({
  imports: [scenarioDropdown.Component],
  selector: 'atn-app-page-header',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
